export default `
	guid
	name
    photo_url
`;
